import { tns } from 'tiny-slider/src/tiny-slider';

(function () {
  const els = document.querySelectorAll('[data-vanilla="main-slider-news"]');

  if (els.length) {
    tns({
      container: '.main-slider-news__container',
      items: 1,
      center: true,
      autoplay: false,
      edgePadding: 10,
      gutter: 20,
      lazyload: true,
      lazyloadSelector: '.news-home-slider-image img',
      autoplayButtonOutput: true,
      loop: true,
      nav: true,
      controls: false,
      controlsText: ['', '']
    });
  }
})();

(function () {
  if (window.matchMedia('(min-width: 992px)').matches) {
    const elss = document.querySelectorAll(
      '[data-vanilla="main-slider-news-lottery"]'
    );
    if (elss.length) {
      tns({
        container: '.main-slider-news__container-lottery',
        items: 5,
        center: true,
        autoplay: false,
        edgePadding: 10,
        lazyload: true,
        lazyloadSelector: '.news-home-slider-image img',
        autoplayButtonOutput: true,
        loop: true,
        nav: true,
        controls: false,
        controlsText: ['', '']
      });
    }
  }
})();
